import React from 'react';
import EventSuperstarSchedule from '../EventSuperstarSchedule/EventSuperstarSchedule';
const SueprstarScheduleCreate = () => {
return( 
    <>
        <EventSuperstarSchedule />
        {/* <NewSchedule/> */}

    </>
)};

export default SueprstarScheduleCreate;